import { Logger, LoggerTransformer } from "@identity/utils";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { WINDOW } from "@identity/symbols";

@singleton()
export class ConsentCallbackQueue {
  readonly queue: Callback[];

  constructor(
    @inject(WINDOW) private window: Window,
    @injectWithTransform(Logger, LoggerTransformer, "ConsentCallbackQueue")
    private logger: Logger,
  ) {
    this.queue = [];
  }

  public install(): ConsentCallbackQueue {
    this.logger.info("installing consent queue");
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    this.window.consentCallbackQueue = this;
    this.window.consentCallback = (name, callback, category) =>
      self.push(name, callback, category);
    return this;
  }

  public push(
    name: string,
    callback: (categories?: Categories) => void,
    requiredCategory?: string,
  ) {
    this.logger.warn("dialog not resolved, enqueued:", name);
    this.queue.push({
      name: name,
      callback: callback,
      category: requiredCategory,
    });
  }
}
